import { render, staticRenderFns } from "./OverviewCardsVT.vue?vue&type=template&id=2d3464e9&scoped=true"
import script from "./OverviewCardsVT.vue?vue&type=script&lang=js"
export * from "./OverviewCardsVT.vue?vue&type=script&lang=js"
import style0 from "./OverviewCardsVT.vue?vue&type=style&index=0&id=2d3464e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3464e9",
  null
  
)

export default component.exports